import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './auth/core/auth-guard.service';
import { UserMailVerifiedGuardService } from './auth/user-mail-verified-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'landing',
    pathMatch: 'full'
  },
  {
    path: 'landing',
    loadChildren: () => import('./auth/landing/landing.module').then( m => m.LandingPageModule)
  },
  // { path: 'auth/callback', loadChildren: './auth/auth/auth-callback/auth-callback.module#AuthCallbackPageModule' },
  // { path: 'auth/endsession', loadChildren: './auth/auth/end-session/end-session.module#EndSessionPageModule' },
  { path: 'auth/callback', loadChildren: () => import('./auth/auth/auth-callback/auth-callback.module')
        .then(m => m.AuthCallbackPageModule) },
  { path: 'auth/endsession', loadChildren: () => import('./auth/auth/end-session/end-session.module').then(m => m.EndSessionPageModule) },
  {
    path: 'questionnaire', canActivate: [AuthGuardService, UserMailVerifiedGuardService],
    loadChildren: () => import('./questionnaire/questionnaire.module').then( m => m.QuestionnairePageModule)
  },
  {
    path: 'food-tracker', canActivate: [AuthGuardService, UserMailVerifiedGuardService],
    loadChildren: () => import('./food-tracker/food-tracker.module').then( m => m.FoodTrackerPageModule)
  },
  {
    path: 'tracker-page', canActivate: [AuthGuardService, UserMailVerifiedGuardService],
    loadChildren: () => import('./food-tracker/tracker/tracker.module').then( m => m.TrackerPageModule)
  },
  {
    path: 'typical-meals', canActivate: [AuthGuardService, UserMailVerifiedGuardService],
    loadChildren: () => import('./typical-meals/typical-meals.module').then( m => m.TypicalMealsPageModule)
  },
  {
    path: 'food-search', canActivate: [AuthGuardService, UserMailVerifiedGuardService],
    loadChildren: () => import('./trackers/food-search/food-search.module').then( m => m.FoodSearchPageModule)
  },
  {
    path: 'register', canActivate: [AuthGuardService],
    loadChildren: () => import('./auth/register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: 'settings', canActivate: [AuthGuardService, UserMailVerifiedGuardService],
    loadChildren: () => import('./settings/settings.module').then( m => m.SettingsPageModule)
  },
  {
    path: 'settings/:subPage', canActivate: [AuthGuardService, UserMailVerifiedGuardService],
    loadChildren: () => import('./settings/settings.module').then( m => m.SettingsPageModule)
  },
  {
    path: 'settings/:subPage/:success', canActivate: [AuthGuardService, UserMailVerifiedGuardService],
    loadChildren: () => import('./settings/settings.module').then( m => m.SettingsPageModule)
  },
  {
    path: 'recipes', canActivate: [AuthGuardService, UserMailVerifiedGuardService],
    loadChildren: () => import('./recipes/recipes.module').then( m => m.RecipesModule)
  },
  {
    path: 'email-not-verified-yet', canActivate: [AuthGuardService],
    loadChildren: () => import('./auth/email-not-verified-yet/email-not-verified-yet.module').then( m => m.EmailNotVerifiedYetPageModule)
  },
  {
    path: 'onboarding',
    loadChildren: () => import('./onboarding/onboarding.module').then( m => m.OnboardingPageModule)
  },
  {
    path: 'crop-image',
    loadChildren: () => import('./crop-image/crop-image.module').then( m => m.CropImagePageModule)
  },
  {
    path: 'testers-menu',
    loadChildren: () => import('./testers-menu/testers-menu.module').then( m => m.TestersMenuPageModule)
  },
  {
    path: 'food-product',
    loadChildren: () => import('./food-details/food-product/food-product.module').then( m => m.FoodProductPageModule)
  },
  {
    path: 'info-hub',
    loadChildren: () => import('./food-tracker/info-hub/info-hub.module').then( m => m.InfoHubPageModule)
  }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
